export default __webpack_public_path__ + "static/media/WorkInProgress.f8687ee0.gif";